import type { SITE_SUBSCRIBER_DETAILS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-subscriber-details-card/site-subscriber-details-card.fr.ts";

export const SITE_SUBSCRIBER_DETAILS_CARD_ENGLISH_LOCALE = {
  title: "Subscriber",
  subscriberId: "Subscriber Id",
  name: "Name",
  mails: "E-mails",
  phones: "Phone numbers",
  noSubscriber: {
    title: "No subscriber",
    subtitle: "No subscriber is linked to the site",
  },
  myVoltalis: "MyVoltalis access",
  flags: {
    privileged: "PSB",
    vip: "VIP",
  },
} satisfies typeof SITE_SUBSCRIBER_DETAILS_CARD_FRENCH_LOCALE;
